var exports = {
  "vK": "TableGameResult.module__banner___NXVmU0",
  "DD": "TableGameResult.module__title___NXVmU0",
  "_0": "TableGameResult.module__detail___NXVmU0",
};

module.exports = exports;
